<template>

    <m-edit1/>

    <m-div v-bind='{...{},...{}}' :style='""' class="container " >
                <template #default>   <m-Alert-1 v-bind='{...{},...{}}' :style='""' class="col-lg-12 text-center" >
                <template #default>«ارسال کلیه سفارش‌ها طی ۲ تا ۵ روز کاری پس از ثبت و تأیید نهایی انجام خواهد شد.»   </template>
                </m-Alert-1><m-factor-4 v-bind='{...{"sellerName":"\u0641\u0631\u0648\u0634\u06af\u0627\u0647 \u0646\u0648\u062f\u0627\u0646\u0648","addressProp":"\u062e\u0648\u0632\u0633\u062a\u0627\u0646 - \u062f\u0632\u0641\u0648\u0644 - \u0628\u0644\u0648\u0627\u0631 \u0645\u0639\u0644\u0645 - \u0628\u06cc\u0646 \u0645\u0642\u0627\u0648\u0645\u062a 17 \u0648 \u062e\u06cc\u0627\u0628\u0627\u0646 \u0645\u0646\u062a\u0638\u0631\u06cc","meliProp":"","signature":"https:\/\/api.nodano.ir\/storage\/assets\/AtLRUbkfmVjiGM8JKP0Y0o0pHFflbau6tKbDBJSh.png","secondImageFactor":""},...{}}' :style='""' class="" ></m-factor-4></template>
                </m-div>

</template>

<script>
import mEdit1 from '@moeinmdn/miw-alpha-components/src/package/Tool/Edit/Edit1'
import {appendTagsToPage} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/Seo";

import mDiv from '@moeinmdn/miw-alpha-components/src/package/Tags/Div'; import mAlert1 from '@moeinmdn/miw-alpha-components/src/package/Alert/Alert1'; import mFactor4 from '@moeinmdn/miw-alpha-components/src/package/ShoppingCart/Factors/Factor4';

export default {
    name: 'HomeView',
    components: {mEdit1, mDiv,mAlert1,mFactor4 },
    mounted() {
       if(this.$route.name === 'Home'){
           appendTagsToPage({}, 'home')
       }
    },
}
</script>


<style scoped>

</style>
